import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from './LoadingSpinner';
import { setLoading, signUpSuccess } from '../../features/authSlice';
import { getMeUser } from '../../api/authApi';
import { showNotification } from './Notification/ToastifyNotification';
import MentorSidebar from './MentorSideBar';
import { checkAllMentorFieldsPresent } from '../const';

const MentorPrivateRoute = ({ children }) => {
  const { loading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const getUser = async () => {
    try {
      const response = await getMeUser();
      if (response.data?.user_id) {
        if (!checkAllMentorFieldsPresent(response.data)) {
          navigate('/manage-profile');
        }
        dispatch(signUpSuccess({
          user: response.data
        }));
        dispatch(setLoading({
          loading: false
        }));
      }
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      dispatch(setLoading({
        loading: false
      }));
      showNotification(errorMessage, 'error');
    }
  }

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(setLoading({
        loading: true
      }));
      getUser();
    }
  }, [localStorage.getItem('token')]);

  // Redirect to login if not authenticated
  if (!localStorage.getItem('token')) {
    return <Navigate to="/mentor" replace />;
  }

  // Render children if authenticated
  return <>
    {loading && (
      <LoadingSpinner />
    )}
    <MentorSidebar children={children} />
  </>;
};

export default MentorPrivateRoute;